<template>
	<div>
		<h2>{{ $t('labels.general.subscription') }}</h2>
		<spinner v-if="subscription.loading"/>
		<div v-else class="idi-table subscription">
			<div class="idi-header">
				<div class="idi-cell">#</div>
				<div class="idi-cell">{{ $t('labels.general.service') }}</div>
				<div class="idi-cell">{{ $t('labels.general.price_by_unit') }}</div>
				<div class="idi-cell">{{ $t('labels.general.units') }}</div>
				<div class="idi-cell">{{ $t('labels.general.total') }}</div>
				<div class="idi-cell">{{ $t('labels.general.payment') }}</div>
				<div class="idi-cell">{{ $t('labels.general.next_payment') }}</div>
				<div class="idi-cell">{{ $t('labels.general.auto_renew') }}</div>
			</div>
			<div class="idi-row">
				<div class="idi-cell">
					<span>{{ subscription.data.id }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ $t(serviceNamesTranslated.get(subscription.data.service_name)) }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ subscription.data.price_unity }}€</span>
				</div>
				<div class="idi-cell">
					<span>{{ subscription.data.units }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ subscription.data.total }}€</span>
				</div>
				<div class="idi-cell">
					<span>{{ $t(paymentFrequencyTranslated.get(subscription.data.frequency_payment)) }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ subscription.data.next_payment_date ? subscription.data.next_payment_date.date : '' | formatDate(vue) }}</span>
				</div>
				<div class="idi-cell">
					<span :class="subscription.data.auto_renew ? 'true' : 'false'">{{ subscription.data.auto_renew ? '✓' : 'ꭙ' }}</span>
				</div>
			</div>
		</div>
		<h2>{{ $t('labels.general.transactions') }}</h2>
		<spinner v-if="transactions.loading"/>
		<div v-else class="idi-table transactions">
			<div class="idi-header">
				<div class="idi-cell">#</div>
				<div class="idi-cell">{{ $t('labels.general.date') }}</div>
				<div class="idi-cell">{{ $t('labels.general.description') }}</div>
				<div class="idi-cell">{{ $t('labels.general.service_period') }}</div>
				<div class="idi-cell">{{ $t('labels.general.state') }}</div>
				<div class="idi-cell">{{ $t('labels.general.subtotal') }}</div>
				<div class="idi-cell">{{ $t('labels.general.total') }}</div>
				<div class="idi-cell"></div>
			</div>
			<div class="idi-row-empty" v-if="!transactions.data.length">
				<div class="idi-cell">{{ $t('labels.general.empty') }}</div>
			</div>
			<div class="idi-row" v-for="transaction in transactions.data" :key="transaction.id">
				<div class="idi-cell">
					<span>{{ transaction.id }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ transaction.create_time | formatDate(vue) }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ transaction.message }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ transaction.period_start | formatDate(vue) }} - {{ transaction.period_end | formatDate(vue) }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ transaction.state }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ transaction.subtotal }}€ <span class="tax">(+{{ transaction.tax }}€ {{ $t('labels.general.tax') }})</span></span>
				</div>
				<div class="idi-cell">
					<span>{{ transaction.total }}€</span>
				</div>
				<div class="idi-cell">
					<router-link
						:to="{ name: 'UserProfileSubscriptionsSubscriptionTransactionView',
						params: { user_uid, subscription_id, subscription_data: subscription.data, transaction_id: transaction.id, transaction_data: transaction } }"
						class="btn btn-round btn-small">{{ $t('labels.general.view') }}</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
import ApiCollection from '@/classes/api/ApiCollection'
export default {
	props: [
		'user_uid',
		'subscription_id',
		'subscription_data'
	],
	data () {
		return {
			vue: this,
			name: 'subscription view',
			services: new ApiCollection(),
			subscription: new ApiObject(),
			transactions: new ApiCollection(),
			paymentFrequencyTranslated: new Map([ [ -2, 'labels.general.yearly' ], [ -1, 'labels.general.monthly' ], [ 0, 'labels.general.daily' ] ]),
			serviceNamesTranslated: new Map([ [ 'Rent watches', 'labels.general.rent_watches' ], [ 'Seats', 'labels.general.seats' ] ]),
		}
	},
	methods: {
		getServicesData () {
			this.services.loading = true
			return this.$api.subscriptions.services.getAll(this)
				.then(response => {
					this.$log.info(this.name, 'subscriptions.services.getAll OK', response)()
					return response.body
				}).catch(error => {
					this.$log.error(this.name, 'subscriptions.services.getAll ERROR', error)()
					this.services.error = error
				}).finally(() => {
					this.services.loading = false
				})
		},
		getSubscriptionData () {
			this.subscription.loading = true
			return this.$api.subscriptions.getById(this, this.user_uid, this.subscription_id)
				.then(response => {
					this.$log.info(this.name, 'subscriptions.getById OK', response)()
					return response.body
				}).catch(error => {
					this.$log.error(this.name, 'subscriptions.getById ERROR', error)()
					this.subscription.error = error
				}).finally(() => {
					this.subscription.loading = false
				})
		},
		getSubscription () {
			Promise.all([this.getServicesData(), this.getSubscriptionData()])
				.then(([services, subscription]) => {
					const map = new Map()
					this.services.data = services
					this.services.data.forEach(ele => { map.set(ele.id, ele.name) })
					const service_name = map.get(subscription.service_id) || ''
					this.subscription.data = { ...subscription, service_name }
				})
		},
		getTransactions () {
			this.transactions.loading = true
			this.$api.subscriptions.transactions.getAll(this, this.user_uid, this.subscription_id)
				.then(response => {
					this.$log.info(this.name, 'subscriptions.transactions.getAll OK', response)()
					this.transactions.data = response.body
				}).catch(error => {
					this.$log.error(this.name, 'subscriptions.transactions.getAll ERROR', error)()
					this.transactions.error = error
				}).finally(() => {
					this.transactions.loading = false
				})
		}
	},
	mounted () {
		this.subscription_data ? this.subscription.data = this.subscription_data : this.getSubscription()
		this.getTransactions()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/subscriptions/SubscriptionView.vue